import React, { PureComponent } from "react";
import { List, Timeline, Typography, Card } from "antd/lib/index";

class LinksDisplay extends PureComponent {
  render() {
    const { pregunta } = this.props;
    return (
      <List
        itemLayout="vertical"
        size="large"
        dataSource={pregunta.preguntas}
        renderItem={(item, i) => (
          <Timeline.Item key={i * 40}>
            <Card.Meta
              avatar={<Typography.Title>{i + 1}</Typography.Title>}
              title={item.titulo}
              description={item.descripcion}
            />
            <a href={item.link}>{item.link}</a>
            <Card.Meta
              title={<a href={item.link}>{item.link}</a>}
              descripcion={<a href={item.link}>{item.link}</a>}
            />
          </Timeline.Item>
        )}
      />
    );
  }
}

export default LinksDisplay;
